import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useGlobalContext } from '../../contexts/GlobalContext';
import RoutesApp from '../../routes';

//Servicios
import { ManagerService, ViniedoService } from '../../services/api';

//Componentes
import Spinner from '../../components/spinner/Spinner';
import Manager from './Manager';

function ManagerContainer() {
    const {
        toast,
        token,
        user,
        viniedos,
        buildBooleanOptions,
        buildSelectOptions,
        isEqualArray,
    } = useGlobalContext();
    const formMethods = useForm();

    const [loader, setLoader] = useState(false);
    const [selectedVineyards, setSelectedVineyards] = useState([]);

    const Params = useParams();
    const Navigate = useNavigate();

    const password = useRef({});
    password.current = formMethods.watch('clave');

    useEffect(() => {
        async function fetchManager() {
            try {
                setLoader(true);

                const Managers = await ManagerService.all({
                    token,
                    usuarioId: user.id,
                });

                if (Managers) {
                    const Manager = Managers.data.find(
                        (m) => m.id === parseInt(Params.id)
                    );
                    Manager.clave = '';
                    formMethods.reset(Manager);

                    const ManagerViniedos = await ViniedoService.all({
                        token,
                        usuarioId: Manager.id,
                    });

                    if (ManagerViniedos) {
                        const Vineyards = ManagerViniedos.data.map((mv) => {
                            return mv.num;
                        });
                        setSelectedVineyards(Vineyards);
                    }
                }

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        }

        fetchManager();
    }, [Params.id]);

    const onSubmit = async (data) => {
        // console.log(data);
        try {
            setLoader(true);

            delete data.confirmPassword;
            delete data.checkAll;

            //Creamos o actualizamos el Encargado
            const Manager = await ManagerService.create({
                token,
                encargado: data,
                viniedos: selectedVineyards,
            });

            if (Manager) {
                Navigate(RoutesApp.Managers.all);
                if (parseInt(Params.id) === 0)
                    toast('Encargado creado con éxito', { type: 'success' });
                if (parseInt(Params.id) !== 0)
                    toast('Encargado actualizado con éxito', {
                        type: 'success',
                    });
                if (Manager.data.confirmado === false)
                    toast(
                        'Revise el correo registrado para verificar la cuenta',
                        {
                            type: 'warning',
                        }
                    );
            }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            toast('No se pudo guardar el encargado', { type: 'error' });
            return err;
        }
    };

    //Funcion para selecionar/deseleccionar todos los viñedos que se quieran asignar al encargado
    const checkAllVineyards = () => {
        const Vineyards = viniedos.map((v) => {
            return v.num;
        });

        isEqualArray(Vineyards, selectedVineyards)
            ? setSelectedVineyards([])
            : setSelectedVineyards(Vineyards);
    };

    const addSelectedVineyards = (e) => {
        if (!selectedVineyards.includes(e.target.value) && e.target.checked) {
            setSelectedVineyards([...selectedVineyards, e.target.value]);
        }
        if (selectedVineyards.includes(e.target.value) && !e.target.checked) {
            setSelectedVineyards(
                selectedVineyards.filter((sv) => sv !== e.target.value)
            );
        }
    };

    return loader ? (
        <Spinner />
    ) : (
        <Manager
            states={{ password, viniedos, selectedVineyards }}
            functions={{
                ...formMethods,
                onSubmit,
                buildBooleanOptions,
                buildSelectOptions,
                setSelectedVineyards,
                checkAllVineyards,
                addSelectedVineyards,
                isEqualArray,
            }}
        />
    );
}

export default ManagerContainer;
